// src/index.tsx
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from "@chakra-ui/react";
import { CartProvider } from "./contexts/CartContext";
import { createDynamicTheme } from './theme';

const ThemedApp = () => {
  const [branding, setBranding] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const subdomain = window.location.hostname.split(".")[0];
    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    fetch(`${backendUrl}/branding/by-subdomain/${subdomain}`)
      .then(res => res.json())
      .then(data => {
        setBranding(data);
        setLoading(false);
      })
      .catch(err => {
        console.error("⚠️ Branding fetch error. Using default theme.", err);
        setBranding({}); // fallback to default theme
        setLoading(false);
      });
  }, []);

  if (loading) return <div>Loading theme...</div>;

  const theme = createDynamicTheme(branding);

  return (
    <ChakraProvider theme={theme}>
      <CartProvider>
        <App />
      </CartProvider>
    </ChakraProvider>
  );
};



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// root.render(
//   <React.StrictMode>
//     <ChakraProvider theme={theme}>
//       <CartProvider>
//         <App />
//       </CartProvider>
//     </ChakraProvider>
//   </React.StrictMode>
// );
root.render(
  <React.StrictMode>
    <ThemedApp />
  </React.StrictMode>
);

reportWebVitals();